import { DepartureInventory, DepartureInventoryResponse, InventoryConfigurationUnits } from '~/types/tours/inventory';

/** Derive the UI's counts exclusively from the passenger movements returned by svc-tour. */
export function deriveDepartureInventory(response: DepartureInventoryResponse): DepartureInventory {
  const configurations = new Map<string, InventoryConfigurationUnits>();
  let units = 0;
  const entries = response.inventory.map((movement, index) => {
    const change = movement.operation === 'allocated' ? 1 : -1;
    const packageConfigurationId = JSON.stringify([
      movement.tourConfiguration.toLowerCase(),
      movement.packageConfiguration.toLowerCase(),
    ]);
    const configuration = configurations.get(packageConfigurationId);

    units += change;
    configurations.set(packageConfigurationId, {
      packageConfigurationId,
      tourConfiguration: movement.tourConfiguration,
      packageConfiguration: movement.packageConfiguration,
      units: (configuration?.units ?? 0) + change,
    });

    return {
      ...movement,
      // The ledger has no entry IDs; preserve every movement, including identical rows.
      id: `${response.departureId}:${index}`,
      packageConfigurationId,
      units: change,
      passenger: { roomType: movement.roomType },
      reservation: { bookingReference: movement.bookingReference, status: movement.reservationStatus },
    };
  });

  return {
    serviceId: response.serviceId,
    departureId: response.departureId,
    season: response.season?.trim() || null,
    units,
    configurations: Array.from(configurations.values()),
    entries,
  };
}
